import MoveDownIcon from '@mui/icons-material/MoveDown';
import { ListItemIcon, MenuItem } from '@mui/material';
import { FC } from 'react';
import { OpenEditType } from '@/types/subroutine';

type SubroutineNewMenuItemProps = {
  subroutineId?: number;
  folderId?: number;
  openEdit: (openEdit: OpenEditType) => void;
  onClose: () => void;
};

const SubroutineNewMenuItem: FC<SubroutineNewMenuItemProps> = (props) => {
  return (
    <MenuItem
      onClick={(e) => {
        props.openEdit({ open: true, id: props.subroutineId, folder: props.folderId, type: 'new' });
        props.onClose();
      }}
    >
      <ListItemIcon>
        <MoveDownIcon fontSize='small' />
      </ListItemIcon>
      New subroutine...
    </MenuItem>
  );
};

export default SubroutineNewMenuItem;
